import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import radsportMark from '../../assets/brand/radsport-mark.svg';

/**
 * Linke Seite der Handy-Kopfleiste auf Detailseiten (Event, Profi-Rennen, News): Zurück-Knopf
 * und Logo. Mobil ist der Knopf der einzige Rückweg, die Breadcrumbs stehen nur auf dem
 * Desktop (Phil, 01.10.2026). Zwei Wege zum selben Ziel übereinander waren einer zu viel.
 */
const AppTopbarBrand: React.FC<{ onBack: () => void }> = ({ onBack }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
    <button className="app-back-button" onClick={onBack} aria-label="Zurück">
      <ChevronLeft size={22} aria-hidden />
    </button>
    <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 6, textDecoration: 'none', minWidth: 0 }}>
      <img src={radsportMark} alt="Radsport Events" width={26} height={26} style={{ display: 'block', objectFit: 'contain', flexShrink: 0 }} />
      <span className="ed-topbar-wordmark" style={{ fontFamily: "'Archivo',sans-serif", fontStyle: 'italic', fontWeight: 800, fontSize: 15, letterSpacing: '-0.01em', color: '#4A4A4A', whiteSpace: 'nowrap' }}>
        Radsport<span style={{ color: '#922C57' }}> Events</span>
      </span>
    </Link>
  </div>
);

export default AppTopbarBrand;
